var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import { useAuth } from './AuthContext';
import { isRestApiMode, apiClient } from '../services/restApi';
const AdminLocationsContext = createContext(undefined);
export const useAdminLocations = () => {
    const context = useContext(AdminLocationsContext);
    if (context === undefined) {
        throw new Error('useAdminLocations must be used within an AdminLocationsProvider');
    }
    return context;
};
export const AdminLocationsProvider = ({ children }) => {
    const [adminLocationIds, setAdminLocationIds] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const { user } = useAuth();
    const loadAdminLocations = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!(user === null || user === void 0 ? void 0 : user.uid)) {
            setAdminLocationIds([]);
            setIsLoading(false);
            return;
        }
        try {
            setIsLoading(true);
            setError(null);
            let newAdminLocationIds;
            if (isRestApiMode()) {
                const locations = yield apiClient.get('/v1/users/me/locations');
                // Filter to only admin/owner memberships (mirrors the Firestore path's role filter)
                newAdminLocationIds = locations
                    .filter(l => l.role === 'admin' || l.role === 'owner')
                    .map(l => l.locationId);
            }
            else {
                const db = getFirestore();
                const locationUsersQuery = query(collection(db, 'locationUsers'), where('userId', '==', user.uid), where('role', 'in', ['admin', 'owner']));
                const locationUsersSnapshot = yield getDocs(locationUsersQuery);
                newAdminLocationIds = locationUsersSnapshot.docs.map(doc => doc.data().locationId);
            }
            setAdminLocationIds(newAdminLocationIds);
            console.log('Admin locations loaded:', newAdminLocationIds);
        }
        catch (err) {
            console.error('Error loading admin locations:', err);
            setError(err instanceof Error ? err.message : 'Failed to load admin locations');
        }
        finally {
            setIsLoading(false);
        }
    }), [user === null || user === void 0 ? void 0 : user.uid]);
    const refreshAdminLocations = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        yield loadAdminLocations();
    }), [loadAdminLocations]);
    // Загружаем список локаций при изменении пользователя
    useEffect(() => {
        loadAdminLocations();
    }, [loadAdminLocations]);
    const value = {
        adminLocationIds,
        isLoading,
        error,
        refreshAdminLocations
    };
    return (_jsx(AdminLocationsContext.Provider, Object.assign({ value: value }, { children: children })));
};
